export default "__VITE_ASSET__D5F2WaO5__"